import {useQuery} from "react-query";
import ShipmentApi from "./Shipment.api";

export function useShipments(query:any){
    return useQuery(["fetchShipments", query], ShipmentApi.getShipments);
}

export function useShipmentsMilestonesAggregation(csrQuery:any){
    return useQuery(["fetShipmentMilestoneAggregations", csrQuery], ShipmentApi.getShipmentMilestoneAggregations);
}

export function useShipmentCSRList(csrQuery:any){
    return useQuery(["fetchCSRList", csrQuery], ShipmentApi.getCSRList);
}

export function useFinalDeliveries(query:any){
    return useQuery(["fetchFinalDeliveries", query], ShipmentApi.getFinalDeliveries);
}

export function useShipment(referenceNumber:string){
    return useQuery([`fetchShipment-${referenceNumber}`, referenceNumber], ShipmentApi.getShipmentById);
}